import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, FormGroup, Label, Input, Row, Col, FormFeedback, Table } from 'reactstrap';
import { reservationActions } from '../_actions';
import * as Yup from 'yup';
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik'
import { FormikSelect as Select, FormikDatePicker, FormikSelectNested as NestedSelect, CCField } from '../_components';
import "react-datepicker/dist/react-datepicker.css";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';

const isRequired = message => value => (!!value ? undefined : message);

class EditReservationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
    this.updateReservation = this.updateReservation.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  updateReservation(values, { props, setSubmitting }) {

      if(values.cc && Array.isArray(values.cc)) {
        this.props.dispatch(reservationActions.update({...values, cc:values.cc.join(","), completed:this.props.completed}))
      }
      else {
        this.props.dispatch(reservationActions.update({...values, values, completed:this.props.completed}))
      }

      setSubmitting(false);
      this.toggle();
      // resetForm();
  }

  render() {
    return (
      <div>
        <Button color="success" className="full-width" onClick={this.toggle}>{this.props.buttonLabel}</Button>
        <Modal size="lg" isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader><h4>Modifier la réservation</h4></ModalHeader>
          <ModalBody>
          <Formik
            ref="formikForm"
            onSubmit={this.updateReservation}
            initialValues={this.props.initialValues}
            validationSchema={Yup.object().shape({
              project: Yup.number()
                .required('Le numéro de projet est requis.'),
              fcnq_division: Yup.number()
                .required('La division FCNQ est requise.'),
              gl_number: Yup.number()
                .required('Le numéro GL est requis.'),
              company: Yup.number()
                .required('La compagnie du voyageur est requise.'),
              notes: Yup.string(),
              modified_notes: Yup.string(),
              cc: Yup.string().nullable(),
              additional_information: Yup.string(),
              destinations : Yup.array().of(
                Yup.object().shape({
                  departure: Yup.string()
                    .required('Required'), // these constraints take precedence
                  arrival: Yup.string()
                    .required('Required'), // these constraints take precedence
                  departure_date: Yup.date()
                    .required('Required'), // these constraints take precedence
                })
              )
              .required('Must have at least one destination') // these constraints are shown if and only if inner constraints are satisfied
              .min(1, 'Must have at least one destination'),
              travelers: Yup.array().of(
                Yup.object().shape({
                  value: Yup.string()
                    .required('Required') // these constraints take precedence
                })
              )
              .required('Must have at least one traveler') // these constraints are shown if and only if inner constraints are satisfied
              .min(1, 'Must have at least one traveler')
            })}
            render={({values, handleChange, handleBlur, handleSubmit, touched, errors, isSaving, lastSaved, saveError, setFieldValue, setFieldTouched, isSubmitting }) =>
              <Form>
                <FormGroup>
                  <Field handleBlur={handleBlur} onChange={(e) => {handleChange(e)}} component={Select} label="Numéro de projet" options={this.props.projects.items} name="project" id="project" value={values.project}/>
                  {errors.project && touched.project && <div className="input-feedback" style={{color:"red"}}>{errors.project}</div>}
                </FormGroup>
                <FormGroup>
                  <Field handleBlur={handleBlur} onChange={(e) => {handleChange(e)}} component={Select} label="Division FCNQ" options={this.props.divisions.items} name="fcnq_division" id="fcnq_division" value={values.fcnq_division}/>
                  {errors.fcnq_division && touched.fcnq_division && <div className="input-feedback" style={{color:"red"}}>{errors.fcnq_division}</div>}
                </FormGroup>
                <FormGroup>
                  <Field handleBlur={handleBlur} onChange={(e) => {handleChange(e)}} component={Select} label="Numéro GL" options={this.props.gl_numbers.items} name="gl_number" id="gl_number" value={values.gl_number}/>
                  {errors.gl_number && touched.gl_number && <div className="input-feedback" style={{color:"red"}}>{errors.gl_number}</div>}
                </FormGroup>
                <FormGroup>
                  <Field handleBlur={handleBlur} onChange={(e) => {handleChange(e)}} component={CCField} label="CC" options={this.props.cc} name="cc" id="cc" value={values.cc}/>
                  {errors.cc && touched.cc && <div className="input-feedback" style={{color:"red"}}>{errors.cc}</div>}
                </FormGroup>
                <FieldArray
                  name="travelers"
                  render={arrayHelpers => (
                    <Table>
                      <thead>
                        <tr>
                          <th>Voyageur</th>
                        </tr>
                      </thead>
                      <tbody>
                      {values.travelers && values.travelers.length > 0 &&
                        values.travelers.map((traveler, index) => (
                          <tr key={index}>
                            <td>
                              <Field handleBlur={handleBlur}  onSelectUser={(email, email_2) => {email?setFieldValue("cc", values.cc + (values.cc?",":"") + email + email_2 ):console.log("no email")}} onChange={(e) => { handleChange(e);}} component={NestedSelect} options={this.props.users.items} name={`travelers[${index}]`} id={`travelers[${index}]`} value={traveler.value}/>
                            </td>
                          </tr>
                        ))
                      }
                      </tbody>
                      <div>
                        { values.travelers && values.travelers.length > 1 && <button
                          type="button"
                          onClick={() => arrayHelpers.pop()} // remove a friend from the list
                        >
                          -
                        </button>}
                        <button
                          type="button"
                          onClick={() => arrayHelpers.push('')} // insert an empty string at a position
                        >
                          +
                        </button>
                      </div>
                    </Table>
                  )}
                />

                <FormGroup>
                  <Field handleBlur={handleBlur} onChange={(e) => {handleChange(e)}} component={Select} label="Compagnie du voyageur" options={this.props.companies.items} name="company" id="company" value={values.company}/>
                  {errors.company && touched.company && <div className="input-feedback" style={{color:"red"}}>{errors.company}</div>}
                </FormGroup>

                <FieldArray
                  name="destinations"
                  render={arrayHelpers => (
                    <Table>
                      <thead>
                        <tr>
                          <th>De</th>
                          <th>À</th>
                          <th>Date de départ</th>
                          <th>Hôtel Requis</th>
                        </tr>
                      </thead>
                      <tbody>
                      {values.destinations && values.destinations.length > 0 &&
                        values.destinations.map((destination, index) => (
                          <tr key={index}>
                            <td>
                              <Field handleBlur={handleBlur} onChange={(e) => {handleChange(e)}} component={NestedSelect} options={this.props.airports.items} name={`destinations[${index}].departure`} id={`destinations[${index}].departure`} value={destination.departure.value}/>
                            </td>
                            <td>
                              <Field handleBlur={handleBlur} onChange={(e) => {handleChange(e)}} component={NestedSelect} options={this.props.airports.items} name={`destinations[${index}].arrival`} id={`destinations[${index}].departure`} value={destination.arrival.value}/>
                            </td>
                            <td>
                              <Field component={FormikDatePicker}  handleBlur={handleBlur} onChange={(e) => {handleChange(e)}} name={`destinations[${index}].departure_date`} id={`destinations[${index}].departure_date`} />
                            </td>
                            <td>
                              <Input onChange={(e) => {handleChange(e)}} tag={Field} type="checkbox" checked={destination.hotel_required} value={destination.hotel_required} name={`destinations[${index}].hotel_required`} id={`destinations[${index}].hotel_required`} />
                            </td>
                          </tr>
                        ))
                      }
                      </tbody>
                      <div>
                        {values.destinations && values.destinations.length > 1 && <button
                          type="button"
                          onClick={() => arrayHelpers.pop()} // remove a friend from the list
                        >
                          -
                        </button>}
                        <button
                          type="button"
                          onClick={() => arrayHelpers.push({departure:"", arrival:"", departure_date:Date.now(), hotel_required:false})} // insert an empty string at a position
                        >
                          +
                        </button>
                      </div>
                    </Table>
                  )}
                />

                <FormGroup>
                  <Label for="notes">Notes Spéciales (eg; allergies alimentaire, pick-up hôtel, annulation des réservation etc.) </Label>
                  <Input onChange={(e) => {handleChange(e)}} invalid={errors.notes && touched.notes} tag={Field} type="text" value={values.notes} name="notes" id="notes" />
                  {errors.notes && touched.notes && <div className="input-feedback" style={{color:"red"}}>{errors.notes}</div>}
                </FormGroup>
                <FormGroup>
                  <Label for="modified_notes">Raison du changement</Label>
                  <Input onChange={(e) => {handleChange(e)}} invalid={errors.modified_notes && touched.modified_notes} tag={Field} type="text" value={values.modified_notes} name="modified_notes" id="modified_notes" />
                  {errors.modified_notes && touched.modified_notes && <div className="input-feedback" style={{color:"red"}}>{errors.modified_notes}</div>}
                </FormGroup>
                <FormGroup>
                  <Label for="additional_information" style={{color:"red", fontWeight:"bold"}}>INFO À AJOUTER POUR LES LISTES DEROULANTE. (Compagnie, Voyageur, etc.) SVP NOTEZ le format pour ajouter un nouvel employé: PRÉNOM, NOM DE FAMILLE, aaaa-mm-jj</Label>
                  <Input onChange={(e) => {handleChange(e)}} invalid={errors.additional_information && touched.additional_information} tag={Field} type="text" value={values.additional_information} name="additional_information" id="additional_information" />
                  {errors.additional_information && touched.additional_information && <div className="input-feedback" style={{color:"red"}}>{errors.additional_information}</div>}
                </FormGroup>
                <Row>
                  <Col xs="6" className="text-center">
                    <Button type="submit" color="primary" onClick={(e) => {handleSubmit(e);}} disabled={isSubmitting}>Modifier</Button>
                  </Col>
                  <Col xs="6" className="text-center" >
                    <Button color="secondary" onClick={this.toggle}>Annuler</Button>
                  </Col>
                </Row>
              </Form>}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { airports, users, companies, projects, divisions, gl_numbers } = state;
  return {
      airports: airports,
      users: users,
      companies: companies,
      projects: projects,
      divisions: divisions,
      gl_numbers: gl_numbers,
  };
}

const connectedEditReservationModal = connect(mapStateToProps)(EditReservationModal);
export { connectedEditReservationModal as EditReservationModal };
